import Page from "webPage/Page";
import Track from "util/Track";
import $ from "jquery";
import Gallery from "webPage/Gallery";

Page.register('page-template-homepage', () => {
    let $galleries = $('.js-gallery');

    if ($galleries.length > 0) {
        $galleries.each(function () {
            new Gallery($(this), {
                itemClass: "card-gallery__main-image",
                pipClass: "pips__item",
                navigateClass: "js-navigate",
                pipsClass: "js-pips",
                itemsClass: "js-items",
                itemActiveModifier: "active",
                pipActiveModifier: "active",
                animationDuration: 200,
            });
        })
    }

    new Track($('.js-track-wrap'), {
        classes: {
            block: "slider",
        },
    });
});
